
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ay1Qf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $70d15605a6fa2d1f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $70d15605a6fa2d1f$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': "\u60A8\u7684\u804A\u5929\u8A18\u9304\u6700\u591A\u53EF\u5132\u5B58 30 \u5929\u3002",
    'ai-mate.chat-error-banner.title': "\u958B\u59CB\u65B0\u804A\u5929",
    'ai-mate.chat-error.description': "\u5617\u8A66<btn>\u91CD\u65B0\u8F09\u5165\u804A\u5929</btn>\u3002",
    'ai-mate.chat-error.rate-limited-description': "\u60A8\u5DF2\u9054\u5230\u8981\u6C42\u7684\u6578\u91CF\u4E0A\u9650\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'ai-mate.chat-error.rate-limited-title': "\u8981\u6C42\u904E\u591A",
    'ai-mate.chat-error.rovo-inactive-description': "\u60A8\u7684\u7DB2\u7AD9\u4F3C\u4E4E\u4E26\u672A\u555F\u7528 Rovo\u3002<link>\u8A2D\u5B9A Rovo</link>",
    'ai-mate.chat-error.rovo-inactive-title': "Rovo \u8655\u65BC\u975E\u4F5C\u7528\u4E2D\u7684\u72C0\u614B",
    'ai-mate.chat-error.title': "\u6211\u5011\u4E0D\u78BA\u5B9A\u767C\u751F\u4E86\u4EC0\u9EBC\u554F\u984C",
    'ai-mate.main-chat.close-chat-button-label': "\u95DC\u9589",
    'ai-mate.main-chat.maximize-chat-button-label': "\u5168\u87A2\u5E55",
    'ai-mate.main-chat.minimize-chat-button-label': "\u5FA9\u539F\u6AA2\u8996",
    'ai-mate.main-chat.new-chat-button-label': "\u65B0\u589E",
    'ai-mate.main-chat.new-chat-button-label-full-screen': "\u65B0\u7684\u804A\u5929",
    'conversation-assistant-button.label': "\u804A\u5929",
    'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': "\u50B3\u9001",
    'highlight-actions.rovo-chat-custom-prompt.placeholder': "\u5411 AI \u8A62\u554F",
    'highlight-actions.rovo-chat-explain-option.text': "\u8AAA\u660E",
    'highlight-actions.rovo-chat-explain-prompt': "\u85C9\u7531\u63DB\u500B\u65B9\u5F0F\u63CF\u8FF0\u4E26\u4E14\u65B0\u589E\u984D\u5916\u7684\u7D30\u7BC0\u4F86\u8AAA\u660E\uFF0C\u4F46\u662F\u8ACB\u4F7F\u7528\u7C21\u55AE\u7684\u8A9E\u8A00\u3001\u7C21\u77ED\u7684\u53E5\u5B50\uFF0C\u4E26\u4E14\u91DD\u5C0D\u539F\u59CB\u63CF\u8FF0\u4E2D\u6240\u4F7F\u7528\u7684\u5C08\u6709\u540D\u8A5E\u63D0\u4F9B\u7BC4\u4F8B\u6216\u5B9A\u7FA9\u3002",
    'highlight-actions.rovo-chat-find-resources-option.text': "\u5C0B\u627E\u8CC7\u6E90",
    'highlight-actions.rovo-chat-find-resources-prompt': "\u5728\u7D44\u7E54\u77E5\u8B58\u5167\uFF0C\u5C0B\u627E\u50C5\u652F\u63F4\u6240\u4F5C\u9673\u8FF0\u7684\u8CC7\u6E90\u3002",
    'highlight-actions.rovo-chat-give-examples-option.text': "\u63D0\u4F9B\u7BC4\u4F8B",
    'highlight-actions.rovo-chat-give-examples-prompt': "\u5F9E\u7D44\u7E54\u8CC7\u6E90\u6216\u516C\u958B\u77E5\u8B58\u4E2D\u63D0\u4F9B\u76F8\u95DC\u4F8B\u5B50\u3002\u5982\u679C\u6C92\u6709\u53EF\u63D0\u4F9B\u7684\u8CC7\u6E90\uFF0C\u8ACB\u5617\u8A66\u63D0\u4F9B\u6BD4\u55BB\u7684\u4F8B\u5B50\uFF0C\u5354\u52A9\u4ED6\u4EBA\u9032\u4E00\u6B65\u4E86\u89E3\u3002",
    'highlight-actions.rovo-chat-give-feedback-option.text': "\u63D0\u4F9B\u610F\u898B\u53CD\u61C9",
    'highlight-actions.rovo-chat-give-feedback-prompt': "\u900F\u904E\u6AA2\u95B1\u63CF\u8FF0\u65B9\u5F0F\u4F86\u63D0\u4F9B\u610F\u898B\u53CD\u61C9\u3002\u91DD\u5C0D\u5B57\u8A5E\u7684\u9078\u64C7\u3001\u6587\u6CD5\u548C\u6A19\u9EDE\u7B26\u865F\u63D0\u4F9B\u770B\u6CD5\u3002\u4FDD\u6301\u7A4D\u6975\u6B63\u9762\uFF0C\u4F46\u4E00\u5F8B\u63D0\u4F9B\u81F3\u5C11\u4E00\u9805\u9700\u8981\u6539\u5584\u6216\u8B8A\u66F4\u7684\u5730\u65B9\u3002",
    'highlight-actions.rovo-chat-more-options.tooltip': "\u804A\u5929\u5EFA\u8B70",
    'highlight-actions.rovo-chat-open-chat.tooltip': "\u958B\u555F\u804A\u5929",
    'highlight-actions.rovo-chat-summarize-option.text': "\u7E3D\u7D50",
    'highlight-actions.rovo-chat-summarize-prompt': "\u51F8\u986F\u5176\u4E2D\u7684\u91CD\u9EDE\u3002\u5C08\u6CE8\u65BC\u91CD\u8981\u8CC7\u8A0A\u4E26\u6392\u9664\u4E0D\u5FC5\u8981\u7684\u7D30\u7BC0\u3002\u5728\u55AE\u4E00\u6BB5\u843D\u4E2D\u63D0\u4F9B\u7C21\u6F54\u7684\u6982\u8FF0\u3002",
    'highlight-actions.rovo-chat.button-text': "\u804A\u5929",
    'highlight-actions.rovo-chat.button-text-ask-in-chat': "\u5728\u804A\u5929\u4E2D\u8A62\u554F",
    'horizontal-scroll-container.scroll-left': "\u5411\u5DE6\u6372\u52D5",
    'horizontal-scroll-container.scroll-right': "\u5411\u53F3\u6372\u52D5"
};

});


//# sourceMappingURL=zh_TW.be1408d2.js.map
